export default __webpack_public_path__ + "2180e42bb6c8a64e1566db3f2e8592d9.woff2";